import { useMemo } from 'react'

import { useQuery } from '@apollo/client/react'

import { useOrganizationId } from '~publish/contexts/AccountContext'
import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

export const ComposerChannelFragment = graphql(`
  fragment ComposerChannelFragment on Channel @_unmask {
    id
    name
    displayName
    service
    type
    avatar
    locationData {
      location
    }
    isLocked
    isDisconnected
    allowedActions
  }
`)

export const GetComposerChannelsList = graphql(
  `
    query GetComposerChannelsList($input: ChannelsInput!) {
      channels(input: $input) {
        id
        ...ComposerChannelFragment
      }
    }
  `,
  [ComposerChannelFragment],
)

export type ComposerChannel = FragmentOf<typeof ComposerChannelFragment>

type UseChannelsReturn = {
  channels: Record<string, ComposerChannel>
  loading: boolean
}

export const useChannels = ({ skip }: { skip: boolean }): UseChannelsReturn => {
  const organizationId = useOrganizationId()
  const { data, loading } = useQuery(GetComposerChannelsList, {
    fetchPolicy: 'cache-first',
    skip: !organizationId || skip,
    variables: {
      input: {
        organizationId: organizationId ?? '',
      },
    },
  })

  const channels = useMemo(() => {
    const output: Record<string, ComposerChannel> = {}
    data?.channels?.forEach((channel) => {
      output[channel.id] = channel
    })
    return output
  }, [data?.channels])

  return {
    channels,
    loading,
  }
}
